import { useMobilityHubPrivate } from '@content-api/provider';
import { Subscription } from '@content-api/api/subscription';
import { useQuery } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';

const filterByCompanyType = (companyType?: string) => (subscription: Subscription) => {
  if (!companyType) return true;
  return subscription.availableForCompanyType.some(
    (type) => type.availableForCompanyType === (companyType as string),
  );
};

const filterByStartDate = (startDate?: string) => (subscription: Subscription) => {
  if (!startDate) return true;
  return subscription.startDate <= startDate;
};

export const useSubscriptionInitialData = (props?: {
  companyType?: string;
  startDate?: string;
}) => {
  const { getSubscriptions } = useMobilityHubPrivate();
  const { companyType, startDate = new Date().toISOString() } = props || {};

  const { data: subscriptionsData, isLoading } = useQuery({
    queryKey: ['available-subscriptions'],
    queryFn: () => getSubscriptions(),
  });

  const filteredSubscriptions = (subscriptionsData?.data || [])
    .filter(filterByCompanyType(companyType))
    .filter(filterByStartDate(startDate))
    .sort((a, b) => a.rank - b.rank);

  if (filteredSubscriptions.length === 0 && !isLoading) {
    Sentry.captureException(new Error(`No subscriptions found`), {
      extra: { companyType, startDate, route: window.location.pathname },
      level: 'error',
    });
  }

  const data: { hasTbaService: boolean; items: Subscription[] } = {
    items: filteredSubscriptions,
    hasTbaService: true,
  };

  return {
    isLoading,
    data,
  };
};
